import React, {
  FunctionComponent,
  PropsWithChildren,
  ReactElement,
} from "react";
import "./ErrorMessage.scss";

const ErrorMessage: React.FC<PropsWithChildren<ErrorMessageProps>> &
  ErrorMessageTemplates = ({ title, children, link }) => {
  return (
    <div className="password-reset-error">
      <h3 className="password-reset-error__title">{title}</h3>
      <div className="password-reset-error__content">{children}</div>
      {link && <div className="password-reset-error__link">{link}</div>}
    </div>
  );
};

export type ErrorMessageProps = {
  title: string;
  link?: ReactElement;
};

type ErrorMessageTemplates = {
  TechnicalError: FunctionComponent;
  FailedVerificationError: FunctionComponent;
};

ErrorMessage.TechnicalError = () => (
  <>
    <p>
      <strong>Ein Fehler ist aufgetreten</strong>
    </p>
    <p>
      Es scheint ein technisches Problem vorzuliegen. Wir bitten um
      Entschuldigung. Bitte versuche es in ein paar Minuten erneut.
    </p>
  </>
);

ErrorMessage.FailedVerificationError = () => (
  <>
    <p>
      <strong>Die Prüfung war leider nicht erfolgreich</strong>
    </p>
    <p>Bitte wende dich an unseren Kundenservice:</p>
    <p>
      <strong>
        <a href="tel:+4922179700700">0221 - 79 700 700</a>
      </strong>
    </p>
    <p>
      Montag bis Samstag: 8:00 Uhr - 22:00 Uhr
      <br />
      Sonntag: 9:00 Uhr - 18:00 Uhr
    </p>
  </>
);

export default ErrorMessage;
